import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { LOG_ERROR } from './constants';

/**
 * This type describes errors known to logErrorSaga.
 * However, since anything can be thrown, the LogErrorFn
 * accepts anything too.
 */
type AppError =
  | {
      code?: string;
      message: string;
    }
  | {
      errors: { message: string }[];
    };

export type LogErrorFunction = (error: AppError | any, origin: string) => void;

export function useLogError(): LogErrorFunction {
  const dispatch = useDispatch();
  return useCallback(
    (error, origin) =>
      dispatch({
        type: LOG_ERROR,
        payload: { error, origin },
      }),
    [],
  );
}
